"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var SellingAgreementButton = function (_a) {
    var sellingAgreementPath = _a.sellingAgreementPath, authenticityToken = _a.authenticityToken;
    var formRef = (0, react_1.createRef)();
    var handleClick = function (event) {
        event.preventDefault();
        dialog_store_1.default.showDialog({
            title: '買取を成立にする',
            description: 'この業者との買取は実際に成立しましたか？<br/>※こちらは買取依頼のボタンではありません',
            btnList: [
                { title: 'はい', callback: function () { return formRef.current && formRef.current.submit(); }, customClass: "btn-blue" },
                { title: 'いいえ', callback: function () { return dialog_store_1.default.hideDialog(); }, customClass: "btn-orange" }
            ],
            customClassName: "selling-agreement-dialog",
            show_time: -1
        });
    };
    return (react_1.default.createElement("form", { action: sellingAgreementPath, method: "POST", ref: formRef },
        react_1.default.createElement("input", { type: "hidden", name: "authenticity_token", value: authenticityToken }),
        react_1.default.createElement("button", { onClick: handleClick, className: "l-users-estimates-requests-messages-index-store-info-sellingagreement-btn" }, "\u8CB7\u53D6\u6210\u7ACB\u3057\u305F\u3089\u30AF\u30EA\u30C3\u30AF")));
};
exports.default = SellingAgreementButton;
